import React from 'react';
import { Layout, Breadcrumb, Typography } from 'antd';
import { Link } from 'react-router-dom';
import { HomeOutlined } from '@ant-design/icons';
import { colors, spacing } from '../../theme/designTokens';

const { Content } = Layout;
const { Title } = Typography;

/**
 * Standard page layout for Library module
 * Includes breadcrumbs, title, optional actions, and content area
 */
function LibraryPage({
  title,
  breadcrumbs = [],
  actions,
  children,
  fullHeight = false,
}) {
  return (
    <Content
      style={{
        minHeight: fullHeight ? 'calc(100vh - 64px)' : 'auto',
        backgroundColor: colors.background.primary,
      }}
    >
      {/* Header section with breadcrumbs and title */}
      <div
        style={{
          padding: `${spacing.lg} ${spacing.xl}`,
          backgroundColor: colors.background.secondary,
          borderBottom: `1px solid ${colors.border.light}`,
        }}
      >
        {/* Breadcrumbs */}
        {breadcrumbs.length > 0 && (
          <Breadcrumb
            style={{ marginBottom: spacing.sm }}
            items={[
              {
                href: '/',
                title: <HomeOutlined />,
              },
              ...breadcrumbs.map((crumb) =>
                crumb.path
                  ? {
                      title: <Link to={crumb.path}>{crumb.label}</Link>,
                    }
                  : {
                      title: crumb.label,
                    }
              ),
            ]}
          />
        )}

        {/* Title and actions */}
        <div
          style={{
            display: 'flex',
            justifyContent: 'space-between',
            alignItems: 'center',
          }}
        >
          <Title level={2} style={{ margin: 0, fontSize: '24px' }}>
            {title}
          </Title>
          {actions && <div>{actions}</div>}
        </div>
      </div>

      {/* Main content */}
      <div
        style={{
          padding: fullHeight ? 0 : spacing.xl,
          minHeight: fullHeight ? 'calc(100vh - 180px)' : 'auto',
        }}
      >
        {children}
      </div>
    </Content>
  );
}

export default LibraryPage;
